import NewsPanel from './NewsPanel';
export default {
  name: 'news-article',
  components: {
    NewsPanel
  },
  props: {
    articleList: {
      type: Array,
      required: true
    },
    total: {
      type: Number,
      required: true
    }
  },
  methods: {
    handlePageChange(pageIndex, pageSize) {
      this.$emit('pageChange', pageIndex, pageSize);
    },
    handleSizeChange(current, size) {
      this.$emit('sizeChange', current, size);
    }
  }
};